import { reportCaseApi, raiseNotificationApi } from 'Constants';
import { Context } from 'Context/Context';
import ReportModal from 'Modals/ReportModal';
import React, { useContext, useEffect, useState } from 'react';
import { FaChevronDown } from "react-icons/fa6";
import { FaChevronUp } from "react-icons/fa6";
import { toast } from 'react-toastify';
import { getCaseType } from 'Utils';



function ReportCase({caseDetails, attorney, updateCaseResponse, onMainModalClose, setRefreshList, setUpdateCaseDets, setUpdateComp}) {
    const { makeApiCallFunc} = useContext(Context);
    const [isReported, setIsReported] = useState(false);
    const [showReportDropDown, setShowReportDropDown] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [reason, setReason] = useState("");
    const {userDetails} = useContext(Context);
    const userInfo = attorney ? attorney.userId : userDetails;
    console.log("caseDetails in report case", caseDetails);
    useEffect(() => {
        console.log("report case", userDetails);
    },[])
   const reportCase = () => {
    makeApiCallFunc(reportCaseApi, {
        caseId: caseDetails.caseId,
        userId: caseDetails.userId,
        reason: reason
    },
                
                (data) => 
                {
                    console.log("data here in allback",data);
                    //setRefreshList(true);
                    const userType = userInfo?.isUserFunder ? "Litigation funder" : "Attorney";
                                                     //test
                    const notificationObj = {
                        title : userType + " removed from case " + getCaseType(caseDetails?.caseDetails?.caseType) + " " + caseDetails?.caseDetails?.caseNumber,
                        is_read : false,
                        sender: "professional",
                        notificationCategory: 1,
                        caseNumber: caseDetails?.caseDetails?.caseNumber,
                        type: "4",
                        receiver:  caseDetails?.caseDetails?.owner,
                        additionalInfo : {
                            "caseId": caseDetails?.caseDetails?._id,
                            "userId": userInfo._id
                        },
                        content: "Unfortunately, the "+userType+" "+userInfo?.firstName+" "+userInfo?.lastName+" is no longer interested in this case. You may continue to seek other "+userType+"s available for your case."
                    }
                    makeApiCallFunc(raiseNotificationApi,
                        notificationObj,
                            (data) => 
                            {
                                onMainModalClose();
                                setShowModal(false);
                                setUpdateComp(prev => !prev);
                            },
                            (error) => console.log(error)
                            );
                   
                    toast.info(caseDetails.caseDetails?.caseNumber  + " reported successfully and removed from your cases list.");
                },
    (data) => console.log(data)
    )
   }
   
    useEffect(() => {
        if(caseDetails)
        {
            if(caseDetails?.reported?.length)
            {
                caseDetails?.reported?.map((det) => {
                   if(det.userId === caseDetails?.userId)
                   {
                        setIsReported(true);
                   }
                })
            }
        }
        
    },[caseDetails]) 
  return (
    <>
    {
        showModal &&
        <>
        {console.log("open")}
        <ReportModal
        uploadNew={showModal}
        onSubmit={reportCase}
        onClose={() => setShowModal(false)}
        />
        </>
    }
    <div className='flex justify-right lg:w-max w-full  '>
        {
        isReported ?
        <div className= 'w-[100px] p-1 text-center justify-center text-gray-800 items-center border-2 bg-gray-600 rounded ml-2 cursor-not-allowed'>
            Reported
        </div>
        :
        <div className='relative w-full '>
            <div 
            onClick={() => setShowReportDropDown(prev => !prev)}
            className={'rounded mr-2   flex justify-between items-center text-white bg-gray-500 px-4 p-2 w-full lg:w-max flex items-end cursor-pointer ' + (showReportDropDown && 'bg-gray-900' )}>
               <div className='mr-2 w-full flex justify-center text-xs lg:text-sm'> Report Case  </div>
                {showReportDropDown ? 
                <FaChevronUp/>
                    :
                <FaChevronDown />
                }
            </div>
            {showReportDropDown &&
            <div className='text-xs flex flex-col shadow-md border-2 absolute  w-max right-2 -top-20 bg-gray-100'>
                <div  onClick={() => {setReason("I think this case may be spam");setShowModal(true)}} className='p-1 hover:bg-gray-400 hover:text-white cursor-pointer'>- I think this case may be spam</div>
                <div  onClick={() => {setReason("This person is trying to sell me something");setShowModal(true)}} className='p-1 hover:bg-gray-400 hover:text-white cursor-pointer'>- This person is trying to sell me something</div>
                <div  onClick={() => {setReason("I think this may be a bot/robot");setShowModal(true)}} className='p-1 hover:bg-gray-400 hover:text-white cursor-pointer'>- I think this may be a bot/robot</div>
            </div>
            }
        </div>
        }
    </div>
    </>
    
  )
}

export default ReportCase